import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  label: string;
  children: ReactNode;
  small?: boolean;
  className?: string;
  labelClassName?: string;
  allThemesWithWhiteBackground?: boolean;
}

function NftDetailsListItem({
  label,
  small = false,
  children,
  className,
  labelClassName,
  allThemesWithWhiteBackground,
}: Props) {
  return (
    <div
      className={twMerge(
        "flex justify-between border-b border-border items-center",
        small ? "h-10" : " h-20",
      )}
    >
      <div
        className={twMerge(
          "sm:basis-36 basis-auto  shrink-0 grow-0 whitespace-nowrap pr-2 text-body-3 my-1 sm:my-0 endemic:text-primary text-secondary",
          labelClassName,
          allThemesWithWhiteBackground && "endemic:text-disabled",
        )}
      >
        {label}
      </div>
      <div className={twMerge("align-right text-body-2", className)}>
        {children}
      </div>
    </div>
  );
}

export default NftDetailsListItem;
